export function getModelEntryNameFromId<T extends { id: string; name: string }>(
  idQueryParamString?: string,
  modelArray: T[] = [],
): false | string[] {
  if (idQueryParamString == null || idQueryParamString.length === 0 || modelArray.length === 0) {
    return false;
  }

  let queryIds: string[] = JSON.parse(idQueryParamString);

  let result = modelArray.reduce((acc: string[], type: T) => {
    if (queryIds.includes(type.id)) {
      acc.push(type.name);
    }

    return acc;
  }, []);

  return result.length > 0 ? result : false;
}
